import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currencyFormat'
})
export class CurrencyFormatPipe implements PipeTransform {
  transform(value: number, currencyCode: string = 'BRL', symbolDisplay: boolean = true, digits?: string): string {
    if (!value && value !== 0) return '';

    const currencyPipe = new CurrencyPipe('pt-BR');
    const newValue = currencyPipe.transform(value, currencyCode, symbolDisplay, digits) ?? '';

    return newValue.replace('R$', '').trim();
  }
}
